export default "__VITE_ASSET__PCqczFzp__"